import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const getShadowRecordsByIds = async (
  shadowRecordIds,
  activeEmployerInfo = {}
) => {
  const apiPath = 'shadow-data/records/by-ids';

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { ids: shadowRecordIds },
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
